module.exports = __webpack_public_path__ + "static/media/mc_rotor.105e39c2.svg";